/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal/Modal";
import ModalContent from "./components/modalContent";
import Actions from "./components/actions";
import Tabs from "./components/tabs";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
import SelectField from "components/SelectField";
import TaxPersonalTable02 from "./components/table-2";
import Footer from "./components/footer";
import TaxPersonalTable03 from "./components/table-3";
import TaxPersonalTable04 from "./components/table-4";
import TaxPersonalTable05 from "./components/table-5";
import TaxPersonalTable06 from "./components/table-6";

const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];

export default function TaxProperty02() {
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([
    { name: "01-1/BK-CNKD", checked: false },
    { name: "01-2/BK-HĐKD", checked: false },
    { name: "PL 43/2022/QH15", checked: false, disabled: true },
    { name: "PL 101/2023/QH15", checked: false, disabled: true },
  ]);
  const [count, setCount] = React.useState(28);

  const handleChangeCount = (number) => setCount(number);

  const { formId, formField } = form;
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai thuế đối với hoạt động cho thuê tài sản
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic">
                (Áp dụng đối với cá nhân có hoạt động cho thuê tài sản trực tiếp khai thuế với cơ
                quan thuế và tổ chức thay cho cá nhân)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    onChangeCount={handleChangeCount}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable02
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    count={count}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable03
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    count={count}
                    setFieldValue={setFieldValue}
                  />
                  <Footer
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />

                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 1 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục bảng kê chi tiết hộ kinh doanh, cá nhân kinh doanh
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic">
                (Kèm theo Tờ khai 01/CNKD áp dụng đối với tổ chức, cá nhân khai thuế thay, nộp thuế
                cho cá nhân; cá nhân hợp tác kinh doanh với tổ chức; tổ chức chi trả cho cá nhân đạt
                doanh số; tổ chức là chủ sở hữu sàn giao dịch thương mai điện tử; tổ chức tại Việt
                Nam là đối tác của nhà cung cấp nền tảng số ở nước ngoài)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields02
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable04
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    count={count}
                    setFieldValue={setFieldValue}
                  />
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 2 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục bảng kê hoạt động kinh doanh trong kỳ của hộ kinh doanh, cá nhân kinh doanh
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic">
                (Kèm theo Tờ khai 01/CNKD áp dụng đối với hộ kinh doanh, cá nhân nộp thuế theo
                phương pháp kê khai)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields02
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable05
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    count={count}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable06
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    count={count}
                    setFieldValue={setFieldValue}
                  />
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData, setFieldValue }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxAgencyName,
    taxAgencyId,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    contract,
    contractDate,

    address,
    authDocument,
    authDocumentDate,
    checkbox1,
    checkbox2,
    district,
    email,
    email2,
    fax,
    fax2,
    field01a,
    field01b,
    field01c,
    field01d,
    organizationName,
    phone,
    phone2,
    province,
    taxId2,
    ward,
    acreage,
    address2,
    address3,
    address4,
    bankNumber,
    businessAddress,
    career,
    checkbox10,
    checkbox3,
    checkbox4,
    checkbox5,
    checkbox6,
    checkbox7,
    checkbox8,
    checkbox9,
    district2,
    province2,
    quantityUse,
    shopName,
    timeActivityFrom,
    timeActivityTo,
    ward2,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox1.name} label={checkbox1.label} value={values.checkbox1} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox2.name} label={checkbox2.label} value={values.checkbox2} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox3.name} label={checkbox3.label} value={values.checkbox3} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox4.name} label={checkbox4.label} value={values.checkbox4} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox5.name} label={checkbox5.label} value={values.checkbox5} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox6.name} label={checkbox6.label} value={values.checkbox6} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={field01a.name}
            label={field01a.label}
            value={values.field01a}
            error={errors.field01a && touched.field01a}
            success={values.field01a?.toString().length > 0 && !errors.field01a}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              plugins: [
                new rangePlugin({
                  shorthand: true,
                  theme: "light",
                  dateFormat: "d/m/Y",
                }),
              ],
              enableTime: false,
            }}
            name={field01b.name}
            label={field01b.label}
            error={errors.field01b && touched.field01b}
            success={values.field01b?.toString().length > 0 && !errors.field01b}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={field01c.name}
            label={field01c.label}
            error={errors.field01c && touched.field01c}
            success={values.field01c?.toString().length > 0 && !errors.field01c}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01d_quy"
            label="[01d] Quý"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01d_quy", +value)}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01d_nam"
            label="[01d] Năm"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01d_nam", +value)}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              plugins: [
                new rangePlugin({
                  shorthand: true,
                  theme: "light",
                  dateFormat: "d/m/Y",
                }),
              ],
              enableTime: false,
            }}
            name={field01d.name}
            label={field01d.label}
            error={errors.field01d && touched.field01d}
            success={values.field01d?.toString().length > 0 && !errors.field01d}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={shopName.name}
            label={shopName.label}
            value={values.shopName}
            error={errors.shopName && touched.shopName}
            success={values.shopName?.toString().length > 0 && !errors.shopName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={bankNumber.name}
            label={bankNumber.label}
            value={values.bankNumber}
            error={errors.bankNumber && touched.bankNumber}
            success={values.bankNumber?.toString().length > 0 && !errors.bankNumber}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={career.name}
            label={career.label}
            value={values.career}
            error={errors.career && touched.career}
            success={values.career?.toString().length > 0 && !errors.career}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox7.name} label={checkbox7.label} value={values.checkbox7} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={acreage.name}
            label={acreage.label}
            value={values.acreage}
            error={errors.acreage && touched.acreage}
            success={values.acreage?.toString().length > 0 && !errors.acreage}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox8.name} label={checkbox8.label} value={values.checkbox8} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={quantityUse.name}
            label={quantityUse.label}
            value={values.quantityUse}
            error={errors.quantityUse && touched.quantityUse}
            success={values.quantityUse?.toString().length > 0 && !errors.quantityUse}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              noCalendar: true,
              enableTime: true,
              dateFormat: "h:i K",
            }}
            name={timeActivityFrom.name}
            label={timeActivityFrom.label}
            error={errors.timeActivityFrom && touched.timeActivityFrom}
            success={values.timeActivityFrom?.toString().length > 0 && !errors.timeActivityFrom}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              noCalendar: true,
              enableTime: true,
              dateFormat: "h:i K",
            }}
            name={timeActivityTo.name}
            label={timeActivityTo.label}
            error={errors.timeActivityTo && touched.timeActivityTo}
            success={values.timeActivityTo?.toString().length > 0 && !errors.timeActivityTo}
          />
        </Grid>
        <Grid item xs={10} style={{ paddingTop: 0 }}>
          <FormField
            name={businessAddress.name}
            label={businessAddress.label}
            value={values.businessAddress}
            error={errors.businessAddress && touched.businessAddress}
            success={values.businessAddress?.toString().length > 0 && !errors.businessAddress}
          />
        </Grid>
        <Grid item xs={2} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox9.name} label={checkbox9.label} value={values.checkbox9} />
        </Grid>

        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={province.label}
            name={province.name}
            value={values.province}
            placeholder={province.placeholder}
            error={errors.province && touched.province}
            success={values.province.length > 0 && !errors.province}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={ward.label}
            name={ward.name}
            value={values.ward}
            placeholder={ward.placeholder}
            error={errors.ward && touched.ward}
            success={values.ward.length > 0 && !errors.ward}
          />
        </Grid>
        <Grid item xs={10} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>
        <Grid item xs={2} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox10.name} label={checkbox10.label} value={values.checkbox10} />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address2.name}
            label={address2.label}
            value={values.address2}
            error={errors.address2 && touched.address2}
            success={values.address2?.toString().length > 0 && !errors.address2}
          />
        </Grid>

        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={province2.label}
            name={province2.name}
            value={values.province2}
            placeholder={province2.placeholder}
            error={errors.province2 && touched.province2}
            success={values.province2.length > 0 && !errors.province2}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={district2.label}
            name={district2.name}
            value={values.district2}
            placeholder={district2.placeholder}
            error={errors.district2 && touched.district2}
            success={values.district2.length > 0 && !errors.district2}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={ward2.label}
            name={ward2.name}
            value={values.ward2}
            placeholder={ward2.placeholder}
            error={errors.ward2 && touched.ward2}
            success={values.ward2.length > 0 && !errors.ward2}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address3.name}
            label={address3.label}
            value={values.address3}
            error={errors.address3 && touched.address3}
            success={values.address3?.toString().length > 0 && !errors.address3}
          />
        </Grid>

        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone.name}
            label={phone.label}
            value={values.phone}
            error={errors.phone && touched.phone}
            success={values.phone?.toString().length > 0 && !errors.phone}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax.name}
            label={fax.label}
            value={values.fax}
            error={errors.fax && touched.fax}
            success={values.fax?.toString().length > 0 && !errors.fax}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email.name}
            label={email.label}
            value={values.email}
            error={errors.email && touched.email}
            success={values.email?.toString().length > 0 && !errors.email}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={authDocument.name}
            label={authDocument.label}
            value={values.authDocument}
            error={errors.authDocument && touched.authDocument}
            success={values.authDocument?.toString().length > 0 && !errors.authDocument}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={authDocumentDate.name}
            label={authDocumentDate.label}
            value={values.authDocumentDate}
            error={errors.authDocumentDate && touched.authDocumentDate}
            success={values.authDocumentDate?.toString().length > 0 && !errors.authDocumentDate}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={contract.name}
            label={contract.label}
            value={values.contract}
            error={errors.contract && touched.contract}
            success={values.contract?.toString().length > 0 && !errors.contract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "d-m-Y",
              enableTime: false,
            }}
            name={contractDate.name}
            label={contractDate.label}
            error={errors.contractDate && touched.contractD}
            success={values.contractDate?.toString().length > 0 && !errors.taxCalculationPeriod}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={organizationName.name}
            label={organizationName.label}
            value={values.organizationName}
            error={errors.organizationName && touched.organizationName}
            success={values.organizationName?.toString().length > 0 && !errors.organizationName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId2.name}
            label={taxId2.label}
            value={values.taxId2}
            error={errors.taxId2 && touched.taxId2}
            success={values.taxId2?.toString().length > 0 && !errors.taxId2}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address4.name}
            label={address4.label}
            value={values.address4}
            error={errors.address4 && touched.address4}
            success={values.address4?.toString()?.length > 0 && !errors.address4}
          />
        </Grid>

        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone2.name}
            label={phone2.label}
            value={values.phone2}
            error={errors.phone2 && touched.phone2}
            success={values.phone2?.toString()?.length > 0 && !errors.phone2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax2.name}
            label={fax2.label}
            value={values.fax2}
            error={errors.fax2 && touched.fax2}
            success={values.fax2?.toString().length > 0 && !errors.fax2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email2.name}
            label={email2.label}
            value={values.email2}
            error={errors.email2 && touched.email2}
            success={values.email2?.toString().length > 0 && !errors.email2}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

function Fields02({ formData, setFieldValue }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxAgencyName,
    taxAgencyId,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    contract,
    contractDate,

    address,
    authDocument,
    authDocumentDate,
    checkbox1,
    checkbox2,
    district,
    email,
    email2,
    fax,
    fax2,
    field01a,
    field01b,
    field01c,
    field01d,
    organizationName,
    phone,
    phone2,
    province,
    taxId2,
    ward,
    acreage,
    address2,
    address3,
    address4,
    bankNumber,
    businessAddress,
    career,
    checkbox10,
    checkbox3,
    checkbox4,
    checkbox5,
    checkbox6,
    checkbox7,
    checkbox8,
    checkbox9,
    district2,
    province2,
    quantityUse,
    shopName,
    timeActivityFrom,
    timeActivityTo,
    ward2,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01b_quy"
            label="[01b] Quý"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01b_quy", +value)}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01b_nam"
            label="[01b] Năm"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01b_nam", +value)}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              plugins: [
                new rangePlugin({
                  shorthand: true,
                  theme: "light",
                  dateFormat: "d/m/Y",
                }),
              ],
              enableTime: false,
            }}
            name={field01d.name}
            label={"[01b] Từ tháng / Đến tháng"}
            error={errors.field01d && touched.field01d}
            success={values.field01d?.toString().length > 0 && !errors.field01d}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              enableTime: false,
              dateFormat: "d/m/Y",
            }}
            name={"eachTime"}
            label={"[01c] Từng lần phát sinh"}
            onChange={(e) => setFieldValue("eachTime", e[0])}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={organizationName.name}
            label={"[04] Tổ chức, cá nhân khai thay"}
            value={values.organizationName}
            error={errors.organizationName && touched.organizationName}
            success={values.organizationName?.toString().length > 0 && !errors.organizationName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId2.name}
            label={"[05] Mã số thuế"}
            value={values.taxId2}
            error={errors.taxId2 && touched.taxId2}
            success={values.taxId2?.toString().length > 0 && !errors.taxId2}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
